<template>
  <v-container
    id="home"
    class="mt-n5 mx-0 px-0"
    style="max-width: 1100px;"
  >
    <div class="headline px-5 mb-2 ml-n3">
      {{ user.first_name ? `Hello, ${user.first_name}.` : '' }}
      <!--<span class="red&#45;&#45;text">
        {{ !isAuthorized ? 'Not Coach' : '' }}
      </span>-->
    </div>

    <v-row
      align="stretch"
      class="mb-5"
    >
      <Banner />
    </v-row>

    <Articles />

    <!-- TODO SNS shower when GCG SNS grow up -->
    <!--<ul
      class="juicer-feed"
      data-feed-id="sccoaching"
    >
      <h1 class="referral">
        <a href="https://www.juicer.io">Powered by Juicer.io</a>
      </h1>
    </ul>-->
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import Banner from './widget/Banner.vue';
import Articles from './widget/Articles.vue';

export default {
  name: 'Home2',

  components: {
    Banner,
    Articles,
  },

  computed: {
    ...mapGetters('account', {
      isAuthorized: 'isAuthorized',
    }),

    ...mapState({
      user: (state) => state.account.user,
    }),
  },
};
</script>

<style lang="scss">
// same as .elevation-3
// .feed-item {
//   box-shadow: 0px 3px 3px -2px rgba(0, 0, 0, 0.2),
//     0px 3px 4px 0px rgba(0, 0, 0, 0.14),
//     0px 1px 8px 0px rgba(0, 0, 0, 0.12) !important;
// }
</style>
